require('../../modules/es6.object.freeze');
module.exports = require('../../modules/_core').Object.freeze;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/fn/object/freeze.js
// module id = 1153
// module chunks = 168707334958949